import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AddResourceForm from './AddResourceForm';

function AddResourcePage() {
    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/resources');
    };

    return (
        <Box>
            <AddResourceForm />
            <Button onClick={handleCancel} variant="outlined" color="secondary" sx={{ mt: 2 }}>
                Cancel
            </Button>
        </Box>
    );
}

export default AddResourcePage;